<template>
    <el-dialog :visible.sync="show" title="添加/修改">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="核销类型">
                <el-radio-group v-model="model.type">
                    <el-radio-button label="消费"></el-radio-button>
                    <el-radio-button label="充值"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="客户">
                <div class="line-container">
                    <el-input style="width:200px" v-model="user" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('user')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle
                        @click.stop="removeItem('user')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="金额">
                <el-input-number v-model="amount"></el-input-number>
            </el-form-item>
            <el-form-item label="录入日期">
                <el-date-picker v-model="model.date" type="datetime" placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="店铺">
                <div class="line-container">
                    <el-input style="width:200px" v-model="store" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('store')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle
                        @click.stop="removeItem('store')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="model.remarks"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectUser, selectStore } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";
import dayjs from "dayjs";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
            amount: 1,
        };
    },
    created() { },
    computed: {
        user() {
            if (this.model.user) {
                return this.model.user.phone + " " + this.model.user.name;
            } else {
                return "";
            }
        },
        store() {
            if (this.model.store) {
                return this.model.store.name;
            } else {
                return "";
            }
        },
    },
    methods: {
        async chooseItem(key) {
            if (key == "user") {
                let item = await selectUser();
                this.$set(this.model, key, item);
            } else if (key == "store") {
                let item = await selectStore();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = {
                type: "消费",
                date: new Date(),
                ...item,
            };
            this.amount =
                this.model && this.model.amount
                    ? Math.abs(this.model.amount)
                    : 1;
        },
        async save() {
            if (!this.model.type) return msgError("请选择核销类型");
            if (!this.model.user) return msgError("请选择客户");
            if (!this.amount) return msgError("请输入金额");
            this.amount = Math.round(this.amount * 100) / 100; // 保留两位小数

            switch (this.model.type) {
                case "消费":
                    this.model.amount = -Math.abs(this.amount);
                    break;
                case "充值":
                    this.model.amount = Math.abs(this.amount);
                    break;
            }

            this.loadingSave = true;
            await HttpClient.put("/restful", {
                model: "Value",
                cond: this.model._id,
                updates: this.model,
            });

            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

<style scoped lang="less">
</style>

        